/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 Marquee3k.init();


// Megamenu toggle
$(document).ready(function() {
    var megamenu = $('#megamenu');
    var hamburger = $('.header_hamburger');
    var header = $('#shopify-section-header');

    hamburger.on('click', function() {
        var isOpen = $(this).attr('aria-expanded') === 'true';

        if (isOpen) {
            // Close megamenu - tutto simultaneo
            $(this).attr('aria-expanded', 'false');
            megamenu.attr('aria-hidden', 'true');
            header.removeClass('Megamenu-open');
        } else {
            // Open megamenu - tutto simultaneo, nessun delay
            header.addClass('Megamenu-open');
            $(this).attr('aria-expanded', 'true');
            megamenu.attr('aria-hidden', 'false');
        }
    });

    // Close megamenu when clicking on a link
    $('.Megamenu__Link').on('click', function() {
        hamburger.attr('aria-expanded', 'false');
        megamenu.attr('aria-hidden', 'true');
        header.removeClass('Megamenu-open');
    });

    // Close megamenu on ESC key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && megamenu.attr('aria-hidden') === 'false') {
            hamburger.attr('aria-expanded', 'false');
            megamenu.attr('aria-hidden', 'true');
            header.removeClass('Megamenu-open');
        }
    });
});


// flickity options for blog
let slideshowEl = document.querySelector(".ArticleList_archive");
if(slideshowEl != undefined){

  let tickerSpeed = 1;

  let flickity = null;
  let isPaused = false;

  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };
  
  const pause = () => {
    isPaused = true;
  };
  
  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };
  

  flickity = new Flickity(slideshowEl,{
    cellAlign: 'left',
    freeScrollFriction: 0.03,
    freeScroll: true,
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: false
  });
  flickity.x = 0;


  slideshowEl.addEventListener('mouseenter', pause, false);
  slideshowEl.addEventListener('focusin', pause, false);
  slideshowEl.addEventListener('mouseleave', play, false);
  slideshowEl.addEventListener('focusout', play, false);
  
  flickity.on('dragStart', () => {
    isPaused = true;
  });
  
  update();
  
}






//
//   Create Flickity
//
//////////////////////////////////////////////////////////////////////

// flickity = new Flickity(slideshowEl, {
//   autoPlay: false,
//   prevNextButtons: true,
//   pageDots: false,
//   draggable: true,
//   wrapAround: true,
//   selectedAttraction: 0.015,
//   friction: 0.25
// });



// flickity options for single blog
let article_slide = document.querySelector(".article_slideshow");
document.addEventListener("DOMContentLoaded", function(event) {
  if(article_slide != undefined){
  Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
      var flkty = new Flickity(".article_slideshow",{
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        autoPlay: true,
        imagesLoaded: true,
        adaptiveHeight: false
      });
      article_slide.classList.remove("hidden")
  });
 }
});


$(document).ready(function() {
  let imageHero = document.querySelector(".Hero_imageContainer");
  if(imageHero != undefined){
    imageHero.classList.add("visible");
  }
});


// header over mobile menu drawer
$(document).ready(function() {
    $(".Header__Icon").on('click', function() {
        $(".shopify-section--header").addClass("above");
    });
    $(".Drawer__Close, .header_link").on('click', function() {
        $(".shopify-section--header").removeClass("above");
    });
});



// Animazione background bianco header allo scroll
$(document).ready(function() {
    var header = $('#shopify-section-header');
    var scrollThreshold = 50; // Pixel di scroll prima di attivare l'animazione

    $(window).on('scroll', function() {
        if ($(window).scrollTop() > scrollThreshold) {
            header.addClass('Header--scrolled');
        } else {
            header.removeClass('Header--scrolled');
        }
    });
});

// sticky header over footer
$(document).ready(function() {
      $(document).on('scroll', function () {
          var distanceFromBottom = $(document).height() - ($(document).scrollTop() + $(window).height());
          if ($(window).width() > 1140) {
            if(distanceFromBottom < 40) {
               $(".header_bottom_row").css("margin-bottom", 40 - distanceFromBottom);
             }
             else {
               $(".header_bottom_row").css("margin-bottom", 0);
             }
          }

          else {
            if(distanceFromBottom < 112) {
               $(".header_bottom_row").css("margin-bottom", 112 - distanceFromBottom);
             }
             else {
               $(".header_bottom_row").css("margin-bottom", 0);
             }
          }


      });
});



// draggable foto stories


$(document).ready(function() {

let container = document.querySelector(".article-stories");
if(container != undefined){

// modale
let modal = document.getElementById("myModal");
let modalImg = document.getElementById("img01");
let caption = document.getElementById("caption");
let modalDida = document.querySelector(".modal_dida")
let img = document.querySelectorAll(".image_container_stories")


var images_stories = gsap.utils.toArray(".image_container_stories");
gsap.to(images_stories, {opacity: 1, duration: 0.4, stagger: 0.06, ease: "ease-in" })

  if(window.innerWidth > 900){

    Draggable.create(".image_container_stories", {
      throwProps:true
    });

    let width =  container.offsetWidth - container.offsetWidth/4;
    let height =  container.offsetHeight - container.offsetHeight/2;


    gsap.set(images_stories,{
      transformOrigin:"50% 50%",
      x: `random(0, ${width})`,
      y: `random(0, ${height})`,
      width: `random(${container.offsetWidth/4}, ${container.offsetWidth/3})`,
    });
  }

    img.forEach((item, i) => {
      if(item.classList.contains("video_poster_container")){
          let video_modal = document.querySelector(`.${item.id}`)
          item.addEventListener("click", function(){
            video_modal.style.display = "flex";
          })
          video_modal.onclick = function() {
            video_modal.style.display = "none";
          }
        }
      else{
        item.addEventListener("click", function(){
          let img2 = item.querySelector("img");
          let dida = item.querySelector(".stories_dida");
          modal.style.display = "flex";
          modalImg.src = img2.src;
          if(dida){
             caption.innerHTML = dida.innerHTML;
          }else{
            caption.innerHTML = "";
          }
        })
      }
    });

    let span = document.getElementsByClassName("close")[0];
    span.onclick = function() {
      modal.style.display = "none";
    }
    modal.onclick = function() {
      modal.style.display = "none";
    }

  }
});
